<template>
	<el-dialog class="z-share" @close="deepClear" :close-on-click-modal="false" :size="'large'" title="奖金分配" :visible.sync="popFlag">
		<div class="head-center-text">{{ data.bonus_cycle_detail | cycleStr }}</div>


		<div class="progress">
			<div class="item" v-for="(item,index) in assets" :key="item.currency_id">
				<div class="text">{{ item.currency_name }}：{{ currency_show[index] }}</div>
				<div class="icon" :class="{green:step==index+1}"></div>
			</div>
		</div>

		<table class="KBTable" cellpadding="0" cellspacing="0" width="100%">
			<thead>
				<tr>
					<td>姓名</td>
					<td>任务数</td>
					<td>异常任务数</td>
					<td>罚单数</td>
					<td>罚币数量(币)</td>
					<td>奖金快币</td>
				</tr>
			</thead>
			<tbody v-form:share>
				<!--成员  -->
				<tr v-for="item in bu_users" :key="item.id">
					<td>{{ item.real_name }}</td>
					<td>{{ item.task_size }}</td>
					<td>{{ item.error_task_size }}</td>
					<td>{{ item.ticket_size }}</td>
					<td>{{ item.ticket_sum }}</td>
					<td> 
						<input type="text" v-tar="assign_list[step-1][item.id]" rule="bonus" v-model="assign_list[step-1][item.id]">
					</td>
				</tr>
			</tbody>
		</table>
		<p class="bonusNotice">注*异常任务指的是执行中被取消的任务</p>
		<p class="bonusNotice">注*分配奖金必须为正整数</p>
		<div slot="footer" class="dialog-footer">
			<el-button v-show="step==1" @click="quit">取 消</el-button>
			<el-button v-show="step>1" type="primary" @click="prevStep">上一步</el-button> 
			<el-button type="primary" :loading="loading" @click="nextStep">{{ step==stepLen?"完成":"下一步" }}</el-button> 
		</div>
	</el-dialog>
</template>

<script type="text/ecmascript-6">

export default {
	props:{
		showFlag:Boolean,
		assets:{
			type:Array,
			default:function(){
				return [];
			},
		},
	},
	data() {
		return {
			step:1,  //当前分配步骤
			loading:false, // 点击完成 loading
			quitCount:0,  //没有点击过取消

			data:{},
		}
	},
	computed: {
		popFlag: {  //控制显示
			// getter
			get: function () {
				return this.showFlag;
			},
			// setter
			set: function (newValue) {
				if (!newValue) {
					this.$emit("close");
				}
			}
		},
		bu_users(){ //成员列表
			return this.data.userList || [];
		},
		assign_list(){  //存分配数据的数组
			return this.assets.map(curr=>{
				return this.bu_users.reduce((obj,user)=>{
					obj[user.id] = 0;
					return obj;
				},{});
			});
		},

		step_dist(){  //最终提交对象
			return this.assets.reduce((obj,curr,index)=>{
				obj[curr.currency_id] = this.assign_list[index];
				return obj;
			},{});

		},
		stepLen(){  //总步数
			return this.assets.length;
		},
		currency_show(){  //头部快币数量   *****没能实现完全，不能实时变化
			return this.assets.map((curr,index)=>{
				let assign_curr = this.assign_list[index];
				let res = 0;
				for(let key in assign_curr){
					let num = assign_curr[key];
					console.log(!isNaN(num))
					if(!isNaN(num)){
						res+= num;
					}
				}
				return curr.dist_balance - res;
			});
		},
	},
	watch: {
		step(val){  //监听step 更改quitCount 值
			if(val==1){
				this.quitCount = 0;
			}
		},
		popFlag(val){
			if(val){
				let url = `api/manager/curr_dist_detail/info`;   //拉分配的人
				this.$http.get(url).then(res=>{
					if(res.status ==200){
						this.data = res.res_data;
					}
				});
			}
		},
	},


	methods: {
		// // ***成员*****
        // getBuMembers(){
        //     let url = `api/manager/bu_user`;
        //     this.$http.get(url).then(res=>{
        //         if(res.status == 200){
        //             this.bu_users = res.res_data.sort((a,b)=>{
        //                 return a.bu_identity_type - b.bu_identity_type
        //             });
        //         }
        //     });
        // },

		clear(obj){
			if(typeof obj == "object"){
				for(let key in obj){
					if(typeof obj[key] == "object"){
						this.clear(obj[key]);
					}else{
						obj[key] = "";
					}
				}
			}
		},
		deepClear(){  //清空数据
			this.clear(this.step_dist);
			this.step = 1;
			this.quitCount = 0;
			this.$form.clear("share");
		},

		// 按钮操作
		quit(){  //点击取消的退出
			if(this.quitCount){
				this.popFlag = false;
				return;
			}
			this.quitCount++;
			this.$message("再次点击取消将退出");
		},
		prevStep(){  //上一步
			this.step--;
			this.$form.clear("share");
		},
		nextStep(){  //下一步和完成
			let res = this.$form.check("share");
			console.log(`验证结果： ${res}`);
			if (!res) {
				return;
			}


			let obj = this.step_dist[this.assets[this.step-1].currency_id];
			let sum = 0;
			for(let key in obj){
				if(!isNaN(obj[key])){
					sum+= parseInt(obj[key]);
				}
			}

			if(sum > this.assets[this.step - 1].dist_balance){
				this.errorTip("分配超标");
				return;
			}

			if(this.step == this.stepLen){
				let url = "api/manager/curr_dist_detail";
				this.loading = true;
				this.$http.post(url,{
					dist:this.step_dist
				}).then(res=>{
					if(res.status == 200){
						this.successTip("分配成功");
						this.popFlag = false;
						this.$emit("getInfo");
					}
					this.loading = false;
				}).catch(error=>{
					this.errorTip("分配失败");
					this.loading = false;
				});
			}else{
				this.step++;
			}
		},

		

	},

}
</script>

<style lang="less">
.z-share {
	.el-dialog__body {
		padding: 0;
		min-height: 400px;
	}

	.head-center-text{
		top: 0;
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
		line-height: 36px;
		color: #01b6ad;
		font-weight: 600;
	}

	.progress{
		display: flex;
		justify-content: space-around;
		border-bottom: 1px solid #d8d8d8;
		padding: 0 20px;
		margin: 20px;
		width: calc(~"100% - 40px*2");

		@width:27px;
		.item{
			position: relative;
			transform: translateY(@width/2);
		}
		.text{
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			white-space: nowrap;
			bottom: calc(~"100% + 5px");
			font-size: 12px;
			color: #808080;
		}
		.icon{
			height: @width;
			width: @width;
			background:#fff url("~src/assets/image/orange_circle.png") no-repeat 9px 9px;
		}
		.green{
			background:#fff url("~src/assets/image/green_circle.png") no-repeat 5px 5px;
		}
	}
	// #bonusWrap {
	// 	background: #ffffff;
	// 	box-shadow: 0px 0px 2px 0px rgba(128, 128, 128, 0.50);
	// 	border-radius: 3px;
	// 	width: 980px;
	// 	height: 540px; // position: absolute;
	// 	// left: 50%;
	// 	// top: 50%;
	// 	// transform: translate(-490px, -270px);
	// 	// z-index: 104;
	// }
	// .header {
	// 	background: #f0f0f0;
	// 	box-shadow: inset 0px -1px 0px 0px rgba(183, 183, 183, 0.50);
	// 	height: 36px;
	// 	line-height: 36px;
	// 	font-size: 14px;
	// 	color: #4d4d4d;
	// 	letter-spacing: 0.72px;
	// 	padding-left: 10px;
	// }
	// .header>span {
	// 	position: absolute;
	// 	right: 5px;
	// 	top: 5px;
	// 	width: 26px;
	// 	height: 26px;
	// 	background: url(../../assets/image/bigX.png) no-repeat;
	// 	cursor: pointer;
	// }
	// .line {
	// 	border-bottom: 1px solid #d8d8d8;
	// 	box-sizing: border-box; // padding: 40px 20px 0px;
	// 	margin: 40px 20px 0px;
	// 	width: calc(~"100% - 40px*2");
	// }

	// .line td {
	// 	overflow: visible;
	// 	position: relative;
	// }

	// .line>tr>td>span {
	// 	position: absolute;
	// 	left: -13px;
	// 	top: -11px;
	// 	display: inline-block;
	// 	width: 27px;
	// 	height: 27px;
	// 	background: #fff url(../../assets/image/orange_circle.png) no-repeat 9px 9px;
	// }

	// .line>tr>td>span.green {
	// 	left: -13px;
	// 	top: -11px;
	// 	width: 27px;
	// 	height: 27px;
	// 	background: #fff url(../../assets/image/green_circle.png) no-repeat 5px 5px;
	// }

	// .line>tr>td>span>span.floatText {
	// 	position: absolute;
	// 	top: -20px;
	// 	left: -60px;
	// 	width: 150px;
	// 	height: 30px;
	// 	line-height: 30px;
	// 	font-size: 12px;
	// 	color: #808080;
	// 	letter-spacing: 0.85px;
	// 	text-align: center;
	// }

	.KBTable {
		text-align: center;
		margin-top: 26px;
	}

	.KBTable thead tr {
		background: #f2f2f2;
		height: 34px;
		font-size: 14px;
		color: #323232;
		letter-spacing: 0.99px;
	}

	.KBTable tbody td {
		height: 45px;
		border-bottom: 1px solid #e6e6e6;
		font-size: 12px;
		color: #808080;
		letter-spacing: 1.33px;
	}

	.KBTable thead td span.question {
		display: inline-block;
		width: 14px;
		height: 14px;
		font-size: 12px;
		background: url("~src/assets/image/description.png") no-repeat;
		cursor: pointer;
		transform: translate(2px, 2px);
		&:hover{
			.questionBox{
				opacity: 1;
			}
		}
	}

	.KBTable thead td span.question .questionBox {
		position: absolute;
		right: -16px;
		top: 10px;
		width: 188px;
		height: 102px;
		background: url("~src/assets/image/box.png") no-repeat;
		transition: 0.3s;
		pointer-events: none;
		opacity: 0;
	}

	.KBTable tr td:nth-of-type(1) {
		width: 14%;
	}

	.KBTable tr td:nth-of-type(2) {
		width: 14%;
	}

	.KBTable tr td:nth-of-type(3) {
		width: 18%;
	}

	.KBTable tr td:nth-of-type(4) {
		width: 20%;
	}

	.KBTable tr td:nth-of-type(5) {
		width: 15%;
	}

	.KBTable .question .questionBox p {
		padding: 0 20px;
		text-align: left;
	}

	.KBTable tbody td input {
		border: 1px solid #d4d4d4;
		border-radius: 2px;
		width: 84px;
		height: 22px;
		padding-left: 10px;
	}

	.bonusNotice {
		text-align: right;
		font-size: 12px;
		color: #808080;
		letter-spacing: 0.99px;
		margin: 10px 20px 0 0;
	}

	.btnGroup {
		position: absolute;
		bottom: 20px;
		right: 0;
	}

	.btnGroup>span {
		float: right;
		border-radius: 2px;
		width: 72px;
		height: 28px;
		color: #fff;
		line-height: 28px;
		text-align: center;
		margin-right: 20px;
		cursor: pointer;
		background: #108ee9;
	}
	/*提醒框*/
	.error {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-140px, -75px);
		background: #ffffff;
		box-shadow: 0px 0px 3px 0px #b3b3b3;
		border-radius: 0px 2px 2px 2px 2px;
		width: 281px;
		height: 150px;
		z-index: 102;
		color: #333333;
	}

	.errorHeader {
		background: #f2f2f2;
		height: 24px;
		font-size: 12px;
		letter-spacing: 0.99px;
		padding-left: 6px;
		line-height: 24px;
	}

	.errorHeader>span {
		position: absolute;
		right: 5px;
		top: 2px;
		display: inline-block;
		width: 20px;
		height: 20px;
		background: url("~src/assets/image/crossSmall.png") no-repeat 5px 5px;
		cursor: pointer;
	}

	.errorContent {
		border: 1px solid #f2f2f2;
		text-align: center;
	}

	.contentTip {
		height: 14px;
		font-size: 14px;
		line-height: 14px;
		margin-top: 25px;
		letter-spacing: 1.16px;
	}

	.contentTip>i {
		display: inline-block;
		height: 14px;
		width: 14px;
		background: url("~src/assets/image/redCross.png") no-repeat;
		margin-right: 6px;
	}

	.contentTip>i.successImg {
		background-image: url("~src/assets/image/rightGreen.png")
	}

	.errorContent p {
		font-size: 10px;
		letter-spacing: 0.83px;
		height: 12px;
		line-height: 12px;
		margin: 10px 0 28px 0;
	}

	.errorBtn {
		background: #108ee9;
		border-radius: 2px;
		width: 48px;
		height: 18px;
		cursor: pointer;
		margin: 10px auto;
		text-align: center;
		color: #fff;
		font-size: 10px;
		letter-spacing: 1.11px;
	}
}
</style>



// WEBPACK FOOTER //
// bonusShare.vue?2b471071